import type { LumoraClient } from "@lumora/bridge";
import { useMfaRequired } from "@lumora/ui";
import { useNavigate } from "react-router-dom";

/** Global 403 `mfa_required` handler: sends the person to the enrol screen with a message. */
export function useMfaRequiredRoute(client: Pick<LumoraClient, "onMfaRequired">, enrollPath: string): void {
  const navigate = useNavigate();
  useMfaRequired(client, () => navigate(enrollPath, { state: { mfaRequired: true } }));
}
